import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { PermissionStatus } from "./Permissions.types";

function _getUserMedia(constraints) {
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    return navigator.mediaDevices.getUserMedia(constraints);
  }

  var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || function () {
    var error = new Error('Permission unimplemented');
    error.code = 0;
    error.name = 'NotAllowedError';
    throw error;
  };

  return new Promise(function (resolve, reject) {
    getUserMedia.call(navigator, constraints, resolve, reject);
  });
}

function askForMediaPermissionAsync(options) {
  var message;
  return _regeneratorRuntime.async(function askForMediaPermissionAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _regeneratorRuntime.awrap(_getUserMedia(options));

        case 3:
          return _context.abrupt("return", {
            status: PermissionStatus.GRANTED,
            expires: 'never',
            canAskAgain: true,
            granted: true
          });

        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          message = _context.t0.message;

          if (!(message === 'Permission dismissed')) {
            _context.next = 13;
            break;
          }

          return _context.abrupt("return", {
            status: PermissionStatus.UNDETERMINED,
            expires: 'never',
            canAskAgain: true,
            granted: false
          });

        case 13:
          return _context.abrupt("return", {
            status: PermissionStatus.DENIED,
            expires: 'never',
            canAskAgain: true,
            granted: false
          });

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[0, 6]], Promise);
}

function askForMicrophonePermissionAsync() {
  return _regeneratorRuntime.async(function askForMicrophonePermissionAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _regeneratorRuntime.awrap(askForMediaPermissionAsync({
            audio: true
          }));

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, null, Promise);
}

function askForCameraPermissionAsync() {
  return _regeneratorRuntime.async(function askForCameraPermissionAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return _regeneratorRuntime.awrap(askForMediaPermissionAsync({
            video: true
          }));

        case 2:
          return _context3.abrupt("return", _context3.sent);

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, null, null, null, Promise);
}

function askForLocationPermissionAsync() {
  return _regeneratorRuntime.async(function askForLocationPermissionAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", new Promise(function (resolve) {
            navigator.geolocation.getCurrentPosition(function () {
              return resolve({
                status: PermissionStatus.GRANTED,
                expires: 'never',
                canAskAgain: true,
                granted: true
              });
            }, function (_ref2) {
              var code = _ref2.code;

              if (code === 1) {
                resolve({
                  status: PermissionStatus.DENIED,
                  expires: 'never',
                  canAskAgain: true,
                  granted: false
                });
              } else {
                resolve({
                  status: PermissionStatus.UNDETERMINED,
                  expires: 'never',
                  canAskAgain: true,
                  granted: false
                });
              }
            });
          }));

        case 1:
        case "end":
          return _context4.stop();
      }
    }
  }, null, null, null, Promise);
}

function getPermissionWithQueryAsync(name) {
  var _await$navigator$perm, state;

  return _regeneratorRuntime.async(function getPermissionWithQueryAsync$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(!navigator || !navigator.permissions || !navigator.permissions.query)) {
            _context5.next = 2;
            break;
          }

          return _context5.abrupt("return", null);

        case 2:
          _context5.next = 4;
          return _regeneratorRuntime.awrap(navigator.permissions.query({
            name: name
          }));

        case 4:
          _await$navigator$perm = _context5.sent;
          state = _await$navigator$perm.state;

          if (!(state === 'prompt')) {
            _context5.next = 10;
            break;
          }

          return _context5.abrupt("return", PermissionStatus.UNDETERMINED);

        case 10:
          if (!(state === 'granted')) {
            _context5.next = 14;
            break;
          }

          return _context5.abrupt("return", PermissionStatus.GRANTED);

        case 14:
          if (!(state === 'denied')) {
            _context5.next = 16;
            break;
          }

          return _context5.abrupt("return", PermissionStatus.DENIED);

        case 16:
          return _context5.abrupt("return", null);

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, null, null, null, Promise);
}

function enumerateDevices() {
  return _regeneratorRuntime.async(function enumerateDevices$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)) {
            _context6.next = 4;
            break;
          }

          _context6.next = 3;
          return _regeneratorRuntime.awrap(navigator.mediaDevices.enumerateDevices());

        case 3:
          return _context6.abrupt("return", _context6.sent);

        case 4:
          if (!(window.MediaStreamTrack && typeof window.MediaStreamTrack.getSources === 'function')) {
            _context6.next = 8;
            break;
          }

          _context6.next = 7;
          return _regeneratorRuntime.awrap(MediaStreamTrack.getSources());

        case 7:
          return _context6.abrupt("return", _context6.sent);

        case 8:
          return _context6.abrupt("return", null);

        case 9:
        case "end":
          return _context6.stop();
      }
    }
  }, null, null, null, Promise);
}

function getMediaMaybeGrantedAsync(targetKind) {
  var devices, result;
  return _regeneratorRuntime.async(function getMediaMaybeGrantedAsync$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return _regeneratorRuntime.awrap(enumerateDevices());

        case 2:
          devices = _context7.sent;

          if (devices) {
            _context7.next = 5;
            break;
          }

          return _context7.abrupt("return", false);

        case 5:
          _context7.next = 7;
          return _regeneratorRuntime.awrap(devices.filter(function (_ref3) {
            var kind = _ref3.kind;
            return kind === targetKind;
          }).some(function (_ref4) {
            var label = _ref4.label;
            return label !== '';
          }));

        case 7:
          result = _context7.sent;
          return _context7.abrupt("return", result);

        case 9:
        case "end":
          return _context7.stop();
      }
    }
  }, null, null, null, Promise);
}

function getPermissionAsync(permission, shouldAsk) {
  var status, _window, _window$Notification, Notification, _status, maybeStatus, _maybeStatus, maybeGranted, _maybeStatus2, _maybeGranted;

  return _regeneratorRuntime.async(function getPermissionAsync$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.t0 = permission;
          _context8.next = _context8.t0 === 'userFacingNotifications' ? 3 : _context8.t0 === 'notifications' ? 3 : _context8.t0 === 'location' ? 20 : _context8.t0 === 'audioRecording' ? 36 : _context8.t0 === 'camera' ? 59 : 82;
          break;

        case 3:
          if (shouldAsk) {
            _context8.next = 9;
            break;
          }

          _context8.next = 6;
          return _regeneratorRuntime.awrap(getPermissionWithQueryAsync('notifications'));

        case 6:
          status = _context8.sent;

          if (!status) {
            _context8.next = 9;
            break;
          }

          return _context8.abrupt("return", {
            status: status,
            expires: 'never',
            granted: status === PermissionStatus.GRANTED,
            canAskAgain: true
          });

        case 9:
          _window = window, _window$Notification = _window.Notification, Notification = _window$Notification === void 0 ? {} : _window$Notification;

          if (!Notification.requestPermission) {
            _context8.next = 19;
            break;
          }

          _status = Notification.permission;

          if (!shouldAsk) {
            _context8.next = 16;
            break;
          }

          _context8.next = 15;
          return _regeneratorRuntime.awrap(Notification.requestPermission());

        case 15:
          _status = _context8.sent;

        case 16:
          if (!(!_status || _status === 'default')) {
            _context8.next = 18;
            break;
          }

          return _context8.abrupt("return", {
            status: PermissionStatus.UNDETERMINED,
            expires: 'never',
            canAskAgain: true,
            granted: false
          });

        case 18:
          return _context8.abrupt("return", {
            status: _status,
            expires: 'never',
            canAskAgain: true,
            granted: _status === PermissionStatus.GRANTED
          });

        case 19:
          return _context8.abrupt("break", 83);

        case 20:
          _context8.next = 22;
          return _regeneratorRuntime.awrap(getPermissionWithQueryAsync('geolocation'));

        case 22:
          maybeStatus = _context8.sent;

          if (!maybeStatus) {
            _context8.next = 31;
            break;
          }

          if (!(maybeStatus === PermissionStatus.UNDETERMINED && shouldAsk)) {
            _context8.next = 28;
            break;
          }

          _context8.next = 27;
          return _regeneratorRuntime.awrap(askForLocationPermissionAsync());

        case 27:
          return _context8.abrupt("return", _context8.sent);

        case 28:
          return _context8.abrupt("return", {
            status: maybeStatus,
            expires: 'never',
            canAskAgain: true,
            granted: maybeStatus === PermissionStatus.GRANTED
          });

        case 31:
          if (!shouldAsk) {
            _context8.next = 35;
            break;
          }

          _context8.next = 34;
          return _regeneratorRuntime.awrap(askForLocationPermissionAsync());

        case 34:
          return _context8.abrupt("return", _context8.sent);

        case 35:
          return _context8.abrupt("break", 83);

        case 36:
          _context8.next = 38;
          return _regeneratorRuntime.awrap(getPermissionWithQueryAsync('microphone'));

        case 38:
          _maybeStatus = _context8.sent;

          if (!_maybeStatus) {
            _context8.next = 47;
            break;
          }

          if (!(_maybeStatus === PermissionStatus.UNDETERMINED && shouldAsk)) {
            _context8.next = 44;
            break;
          }

          _context8.next = 43;
          return _regeneratorRuntime.awrap(askForMicrophonePermissionAsync());

        case 43:
          return _context8.abrupt("return", _context8.sent);

        case 44:
          return _context8.abrupt("return", {
            status: _maybeStatus,
            expires: 'never',
            canAskAgain: true,
            granted: _maybeStatus === PermissionStatus.GRANTED
          });

        case 47:
          if (!shouldAsk) {
            _context8.next = 53;
            break;
          }

          _context8.next = 50;
          return _regeneratorRuntime.awrap(askForMicrophonePermissionAsync());

        case 50:
          return _context8.abrupt("return", _context8.sent);

        case 53:
          _context8.next = 55;
          return _regeneratorRuntime.awrap(getMediaMaybeGrantedAsync('audioinput'));

        case 55:
          maybeGranted = _context8.sent;

          if (!maybeGranted) {
            _context8.next = 58;
            break;
          }

          return _context8.abrupt("return", {
            status: PermissionStatus.GRANTED,
            expires: 'never',
            canAskAgain: true,
            granted: true
          });

        case 58:
          return _context8.abrupt("break", 83);

        case 59:
          _context8.next = 61;
          return _regeneratorRuntime.awrap(getPermissionWithQueryAsync('camera'));

        case 61:
          _maybeStatus2 = _context8.sent;

          if (!_maybeStatus2) {
            _context8.next = 70;
            break;
          }

          if (!(_maybeStatus2 === PermissionStatus.UNDETERMINED && shouldAsk)) {
            _context8.next = 67;
            break;
          }

          _context8.next = 66;
          return _regeneratorRuntime.awrap(askForCameraPermissionAsync());

        case 66:
          return _context8.abrupt("return", _context8.sent);

        case 67:
          return _context8.abrupt("return", {
            status: _maybeStatus2,
            expires: 'never',
            canAskAgain: true,
            granted: _maybeStatus2 === PermissionStatus.GRANTED
          });

        case 70:
          if (!shouldAsk) {
            _context8.next = 76;
            break;
          }

          _context8.next = 73;
          return _regeneratorRuntime.awrap(askForCameraPermissionAsync());

        case 73:
          return _context8.abrupt("return", _context8.sent);

        case 76:
          _context8.next = 78;
          return _regeneratorRuntime.awrap(getMediaMaybeGrantedAsync('videoinput'));

        case 78:
          _maybeGranted = _context8.sent;

          if (!_maybeGranted) {
            _context8.next = 81;
            break;
          }

          return _context8.abrupt("return", {
            status: PermissionStatus.GRANTED,
            expires: 'never',
            canAskAgain: true,
            granted: true
          });

        case 81:
          return _context8.abrupt("break", 83);

        case 82:
          return _context8.abrupt("break", 83);

        case 83:
          return _context8.abrupt("return", {
            status: PermissionStatus.UNDETERMINED,
            expires: 'never',
            canAskAgain: true,
            granted: false
          });

        case 84:
        case "end":
          return _context8.stop();
      }
    }
  }, null, null, null, Promise);
}

export default {
  get name() {
    return 'ExpoPermissions';
  },

  getAsync: function getAsync(permissionTypes) {
    var results, _iterator, _step, permissionType;

    return _regeneratorRuntime.async(function getAsync$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            results = {};
            _iterator = _createForOfIteratorHelperLoose(new Set(permissionTypes));

          case 2:
            if ((_step = _iterator()).done) {
              _context9.next = 9;
              break;
            }

            permissionType = _step.value;
            _context9.next = 6;
            return _regeneratorRuntime.awrap(getPermissionAsync(permissionType, false));

          case 6:
            results[permissionType] = _context9.sent;

          case 7:
            _context9.next = 2;
            break;

          case 9:
            return _context9.abrupt("return", results);

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, null, null, null, Promise);
  },
  askAsync: function askAsync(permissionTypes) {
    var results, _iterator2, _step2, permissionType;

    return _regeneratorRuntime.async(function askAsync$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            results = {};
            _iterator2 = _createForOfIteratorHelperLoose(new Set(permissionTypes));

          case 2:
            if ((_step2 = _iterator2()).done) {
              _context10.next = 9;
              break;
            }

            permissionType = _step2.value;
            _context10.next = 6;
            return _regeneratorRuntime.awrap(getPermissionAsync(permissionType, true));

          case 6:
            results[permissionType] = _context10.sent;

          case 7:
            _context10.next = 2;
            break;

          case 9:
            return _context10.abrupt("return", results);

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, null, null, null, Promise);
  }
};